import React, { useEffect } from "react";

import { styled } from '@mui/material';
import { useAppSelector } from "../../hooks/redux";
import { useDispatch } from "react-redux";

import { actions as nftActions } from '../../services/nfts';
import NftCard from "../../components/NftCard/NftCard";
import CustomGrid from "../../components/CustomGrid";
import { NftData } from "../../types/nft";

const Root = styled('div')({
  flex: 1,
  position: 'relative',
});


const Gallery: React.FC = () => {
  const dispatch = useDispatch();
  const filters = useAppSelector(state => state.filter);
  const nfts = useAppSelector(state => state.nfts);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(nftActions.load(false));
    }, 200);

    return () => {
      clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters.rarity, filters.traits ]);

  const loadMore = () => {
    dispatch(nftActions.load(true));
  }

  return (
    <Root>
      <CustomGrid
        id="nft-cards"
        onLoadMore={loadMore}
        items={nfts.list}
        itemWidth={300}
        itemHeight={300}
        spacing={10}
        isLoadingMore={nfts.loadingMore}
        alignToCenter
        onRenderItem={(nftData: NftData) => {
          return (
            <NftCard data={nftData} url={`/nft/${nftData.tokenId}`} size={300}/>
          )
        }}
      />
    </Root>
  );
};

export default Gallery;